import templateUrl from 'emun.vendor/vendor-paymentgateway-credentials.htm'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import AutoQuery from 'servicestack/auto-query/auto-query.es6'
import ServiceBus from 'servicestack/service-bus'
import modals from 'webmodals/modals'

class VendorPaymentGatewayCredentialsController {
    constructor($scope) {
      const $ctrl = this;
      basicController($ctrl);
      $ctrl.bus = new ServiceBus();

      $ctrl.request = {};

      $ctrl.gateways = [
        {
          id: "authorizeNet",
          name: "Authorize.NET",
          credentials: [
            {
              id: "username",
              label: "Username",
              description: "Merchant's unique API Login ID",
              notes: "Merchant's unique API Login ID"
            },
            {
              id: "password",
              label: "Password",
              description: "Merchant's unique Transaction Key",
              notes: "Merchant's unique Transaction Key"
            }
          ]
        },
        {
          id: "bluepay",
          name: "Bluepay",
          credentials: [
            {
              id: "merchantId",
              label: "Merchant ID",
              description: "BluePay Account ID",
              notes: "BluePay Account ID"
            },
            {
              id: "privateKey",
              label: "Private Key",
              description: "BluePay Secret Key",
              notes: "BluePay Secret Key"
            }
          ]
        },
        {
          id: "braintree",
          name: "Braintree",
          credentials: [
            {
              id: "merchantId",
              label: "Merchant ID",
              description: "Merchant ID",
              notes: "This is the unique identifier for your entire Braintree gateway account, including the multiple merchant accounts that may be in your gateway. Often referred to as the public ID or production ID, your Braintree merchant ID will be different for your production and sandbox gateways."
            },
            {
              id: "publicKey",
              label: "Public Key",
              description: "Public Key",
              notes: "This is your Braintree user-specific public identifier. Each user associated with your Braintree gateway will have their own public key."
            },
            {
              id: "privateKey",
              label: "Private Key",
              description: "Private Key",
              notes: "This is your Braintree user-specific private identifier. Each user associated with your Braintree gateway will have their own private key. Your private key should not be shared outside the use of an API call."
            }
          ]
        },
        {
          id: "cardconnect",
          name: "CardConnect",
          credentials: [
            {
              id: "username",
              label: "Username",
              description: "Username",
              notes: "Username"
            },
            {
              id: "password",
              label: "Password",
              description: "Password",
              notes: "Password"
            },
            {
              id: "merchantId",
              label: "Merchant ID",
              description: "Merchant ID",
              notes: ""
            }
          ]
        },
        {
          id: "chase",
          name: "Chase Paymenttech",
          credentials: [
            {
              id: "merchantId",
              label: "Merchant ID",
              description: "Merchant ID",
              notes: ""
            },
            {
              id: "bin",
              label: "Bin",
              description: "Bin",
              notes: ""
            },
            {
              id: "terminalId",
              label: "Terminal ID",
              description: "Terminal ID",
              notes: ""
            }
          ]
        },
        {
          id: "cybersource",
          name: "Cybersource",
          credentials: [
            {
              id: "merchantId",
              label: "Merchant ID",
              description: "Your Cybersource merchant Id",
              notes: "Your Cybersource merchant Id"
            },
            {
              id: "publicKey",
              label: "Public Key",
              description: "Public Key",
              notes: "API Key Id"
            },
            {
              id: "privateKey",
              label: "Private Key",
              description: "Private Key",
              notes: "Shared Secret Key associated with API Key for HTTP Signature Authentication"
            }
          ]
        },
        {
          id: "ebizcharge",
          name: "EBiz Charge",
          credentials: [
            {
              id: "userId",
              label: "User ID",
              description: "User ID",
              notes: ""
            },
            {
              id: "password",
              label: "Password",
              description: "Password",
              notes: ""
            },
            {
              id: "securityId",
              label: "Security ID",
              description: "Security ID",
              notes: ""
            }
          ]
        },
        {
          id: "elavon",
          name: "Elavon",
          credentials: [
            {
              id: "merchantId",
              label: "Merchant ID",
              description: "Merchant ID",
              notes: "	Merchant ID: Elavon-assigned Converge account ID"
            },
            {
              id: "username",
              label: "Username",
              description: "Username",
              notes: "Converge User ID: The user ID with Hosted Payment API User status that can send transaction requests through the terminal"
            },
            {
              id: "password",
              label: "Password",
              description: "Password",
              notes: "Terminal ID: Unique identifier of the terminal that will process the transaction request and submit to the Converge gateway"
            }
          ]
        },
        {
          id: "hostedpci",
          name: "Hosted PCI",
          credentials: []
        },
        {
          id: "merchantesolution",
          name: "Merchant eSolution",
          credentials: [
            {
              id: "profileId",
              label: "Profile ID",
              description: "Profile ID",
            },
            {
              id: "profileKey",
              label: "Profile Key",
              description: "Profile Key",
            },
          ]
        },
        {
          id: "paytrace",
          name: "PayTrace",
          credentials: [
            {
              id: "username",
              label: "Username",
              description: "Username",
            },
            {
              id: "password",
              label: "Password",
              description: "Password",
            },
            {
              id: "integratorId",
              label: "Integrator ID",
              description: "Integrator ID",
            }
          ]
        },
        {
          id: "quickbooks",
          name: "Quickbooks",
          credentials: [
            {
              id: "username",
              label: "Username",
              description: "Username",
            },
            {
              id: "password",
              label: "Password",
              description: "Password",
            },
            {
              id: "refreshToken",
              label: "Refresh Token",
              description: "Refresh Token",
            }
          ]
        },
        {
          id: "stripe",
          name: "Stripe",
          credentials: [
            {
              id: "merchantId",
              label: "Merchant ID",
              description: "Merchant ID",
              notes: "Your Stripe account ID"
            },
            {
              id: "privateKey",
              label: "Private Key",
              description: "Private Key",
              notes: "Your Stripe secret key provisions in the Stripe dashboard. Prefixed with _sk_live**"
            }
          ]
        },
        {
          id: "usaepay",
          name: "USAePay",
          credentials: [
            {
              id: "sourceKey",
              label: "Source Key",
              description: "Source Key",
              notes: "Source Key"
            },
            {
              id: "pin",
              label: "Pin",
              description: "Pin",
              notes: "Pin"
            }
          ]
        },
        {
          id: "versapay",
          name: "VersaPay",
          credentials: [
            {
              id: "username",
              label: "API User Name",
              description: "API User Name",
              notes: "API User Name"
            },
            {
              id: "password",
              label: "API Password",
              description: "API Password",
              notes: "API Password"
            }
          ]
        }
      ]
      if ($ctrl.$session.isRetailer && !$ctrl.vendorId) $ctrl.vendorId = $ctrl.$session.retailerId;
      $ctrl.bus
      .send("QueryVendors.json?Active=1&Id=" + $ctrl.vendorId)
      .then(function(res) {
        if (res.data.results.length > 0) {
          $ctrl.vendor = res.data.results[0];

          $ctrl.bus.send("AWS/GetSecret.json?SecretName=SFTP/" + $ctrl.vendor.id).then(function(res) {
            var secretPayload = JSON.parse(res.data.secretString);
            if (secretPayload['gateway-gateway']) {
                $ctrl.gateways.map(g => {
                  if (g.id == secretPayload['gateway-gateway']) $ctrl.selectedGateway = g;
                })
                $ctrl.gatewayChanged();
                $ctrl.selectedGateway.credentials.map(c => {
                  if (secretPayload["gateway-" + c.id]) {
                    $ctrl.request[c.id] = secretPayload["gateway-" + c.id];
                  }
                })
            }
          });          
        }
      });
    }
    gatewayChanged() {
      const $ctrl = this;
      if ($ctrl.selectedGateway) {
        $ctrl.request = {
          gateway: $ctrl.selectedGateway.id
        }
      }
    }
    enterCreds() {
      const $ctrl = this;
      $ctrl.edit = true;
      $ctrl.gatewayChanged();
    }
    save() {
      const $ctrl = this;
      $ctrl.bus.send("AWS/SavePaymentGatewayCredentials", {
        VendorId: $ctrl.vendor.id,
        CredentialsData: $ctrl.request
      }).then((res) => {
        $ctrl.edit = false;
        modals.alert("Payment Gateway Credentials save succesfully");
      })
    }
}

export default {
	bindings: {
        vendorId: '@'
	},
    controller: VendorPaymentGatewayCredentialsController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
};